angular.module('logbook')
.directive('alertTriggerCell', ['$http', '$interval', '$location', '$rootScope', '$q', '$timeout', 'batchRequest',
	function($http, $interval, $location, $rootScope, $q, $timeout, batchRequest) {
return {
	
	restrict: 'E',
	template: require('./alert-trigger-cell.html'),
	
	scope: {
		onBind: '=',
		trigger: '=',
		onDelete: '='
	},
	
	link: function(scope, elem, attr)
	{
		var readyForSave = false;
		var $parameterTable = $(elem).find('#table-parameter');
		
		// For storing parameter mapping verification results to prevent double checking
		var verificationResults = {};

		scope.textInput = false;

		scope.baseUrl = $location.absUrl().split("/#")[0];
		scope.selectizeInstances = {};
		
		scope.timeout = undefined;

		/**
		 * @type {SubTemplateMap}
		 */
		scope.selectizeOptions = new SubTemplateMap([]);

		scope.alert = scope.trigger.alertObject;
		
		/**
		 * Clears and resets the trigger mappings selections in all selectize Instances. If the previous selection exists
		 *  in the new set it is selected again.
		 */
		scope.refreshParameterTable = function()
		{
			var options = scope.selectizeOptions.getSelectizeOptions(scope.subTemplateId);
			Object.values(scope.selectizeInstances).forEach(function(instance)
			{
				var setBack = false;
				var currentSelection = (instance.items.length) ? instance.items[0] : -1;

				// Checks if the current selected value is present in the new choices.
				if (currentSelection > -1 && options.options.find(function(segment) { return segment.id == currentSelection }))
				{
					setBack = true;
					instance.removeItem(currentSelection, true);
				}

				instance.clearOptions();
				instance.clearOptionGroups();

				options.optgroups.forEach(function(optGroup)
				{
					instance.addOptionGroup(optGroup.groupName, optGroup);
				});

				instance.addOption(options.options);

				// If the previously selected item was present, the item is selected again.
				// Resolves an issue with items being grouped incorrectly.
				if (setBack)
					instance.addItem(currentSelection, true);
				else
				{
					instance.settings.onChange();
					instance.removeItem(currentSelection);
					instance.removeOption(currentSelection);
				}

				instance.refreshOptions(false);
			});
		};
		
		/**
		 * Sets the parameter options and sub template information for this trigger cell and refreshes the parameters.
		 * @param {SubTemplateMap} subTemplateMap
		 * @param {Number} subTemplateId
		 */
		scope.addParameterOptions = function(subTemplateMap, subTemplateId)
		{
			scope.subTemplateId = subTemplateId;
			scope.selectizeOptions = subTemplateMap;
			scope.refreshParameterTable();
		};
		
		/**
		 * Initializes a selectize instance from the directive. This function should only be called through ng-init
		 * @param {Number} index - Parameter Index
		 * @param {AlertParameter} parameter
		 */
		scope.initializeSelectize = function(index, parameter)
		{
			$timeout(function()
			{
				parameter.isLiteralText = false;

				var key = parameter.id;
				
				// Gets the available items to be placed into selectize from the SubTemplateMap.
				var options = scope.selectizeOptions.getSelectizeOptions(scope.subTemplateId);
				var parameterMapping = scope.trigger.parameterMappings.find(function(paramMap) { return paramMap.parameter.id === parameter.id })
					|| parameter.createParameterMapping(scope.trigger);

				parameterMapping.parameter = parameter;

				var previousItems = (scope.selectizeInstances[key])
					? scope.selectizeInstances[key].items.map(function(item) { return scope.selectizeOptions[key].options[item] })
					: [];
				options.options = options.options.concat(previousItems);
				
				// Get selector for input based on index
				var $selector = $($parameterTable).find('input.template-selector[index=' + index + ']');
				var localSelectize = scope.selectizeInstances[key] = $selector.selectize(
					{
						valueField: 'id',
						labelField: 'name',
						sortField: ['itemGroup', 'name', 'id'],
						searchField: ['name', 'itemGroup'],
						optgroups: options.optgroups.concat([{groupName: 'Text Constant'}]),
						optgroupField: options.optGroupField,
						optgroupLabelField: options.optgroupLabelField,
						optgroupValueField: options.optgroupValueField,

						options: options.options,
						maxItems: 1,
						items: previousItems,
						dropdownParent: 'body',
						onChange: function(value)
						{
							if (scope.selectizeOptions.hasSegmentId(value))
								parameterMapping.templateSegment = value;
							else
							{
								parameterMapping.templateSegment = undefined;
							}
							scope.verifyForSave();

							// To update ng-models on parameter change
							$timeout();
						}
					})[0].selectize;

				// Sets initial values from load if present
				if (parameterMapping.templateSegment)
				{
					var setItem = Object.values(localSelectize.options).find(function(option)
					{
						return option.id.toString() === parameterMapping.templateSegment.toString();
					});

					if (setItem)
						localSelectize.addItem(setItem.id, true);
				}
				
				// Sets parameter to literal text mode if the parameter mapping has a string
				else if (parameterMapping.stringValue.length)
				{
					parameter.isLiteralText = true;
					$($parameterTable).find('input.literal-text-input[index=' + index + ']')
						.val(parameterMapping.stringValue);
				}
				
				scope.verificationCountdown();
			})
		};
		
		/**
		 * Sets literal text mode on parameter and trigger verification countdown
		 * @param {AlertParameter} parameter
		 * @param {Boolean} isTextMode
		 */
		scope.toggleTextMode = function(parameter, isTextMode)
		{
			$timeout(function()
			{
				parameter.isLiteralText = isTextMode;
				scope.verificationCountdown();
			});
		};
		
		scope.getReportTrigger = function()
		{
			return scope.trigger;
		};
		
		/**
		 * Sets a timeout for when save verification should run
		 */
		scope.verificationCountdown = function()
		{
			readyForSave = false;
			
			if (!isNaN(parseInt(scope.timeout)))
				window.clearTimeout(scope.timeout);
			
			scope.timeout = window.setTimeout(scope.verifyForSave, 600);
		};
		
		/**
		 * Returns a promise to either be resolved or rejected on whether saving should be possible
		 * @return {Promise}
		 */
		scope.verifyForSave = function()
		{
			// Resolve promise for each parameter mapping.
			return $q.all(scope.trigger.parameterMappings.map(function(parameterMapping)
			{
				scope.getParameterConstraint(parameterMapping.parameter);
				
				var defer = $q.defer();
				
				// Result of the verification on the parameter mapping
				var result = false;
				
				defer.promise
					.then(function()
					{
						result = true;
						
					},
					function()
					{
						result = false;
					});
				
				defer.promise.finally(function()
				{
					// Store result for reuse later
					verificationResults[parameterMapping.parameter.id] = {
						required: parameterMapping.parameter.required,
						isText: parameterMapping.parameter.isLiteralText,
						value: (parameterMapping.parameter.isLiteralText) ? parameterMapping.stringValue : parameterMapping.templateSegment,
						result: result
					};
					
					// When promise is completed the verification flag is cleared
					parameterMapping.parameter.verificationRunning = false;
				});
				
				if (!parameterMapping.verifyMapping())
					defer.reject();
				
				// If verification result is the same type and value, the original result will be used to avoid rerunning verification
				var verificationResult = verificationResults[parameterMapping.parameter.id];
				if (verificationResult)
				{
					var currentValue = (parameterMapping.parameter.isLiteralText) ? parameterMapping.stringValue : parameterMapping.templateSegment;
					
					if (verificationResult.isText === parameterMapping.parameter.isLiteralText && verificationResult.value === currentValue)
					{
						if (verificationResult.result)
							defer.resolve();
						else
							defer.reject();
						return;
					}
					
				};
				
				if (typeof parameterMapping.parameter.verifyForSave === 'function')
				{
					// Sets verification flag on parameter
					parameterMapping.parameter.verificationRunning = true;
					
					// Defer for if additional items are needed before verification is ran
					// To be resolved with string array of items to verify on
					var requestDefer = $q.defer();
					
					if (parameterMapping.parameter.isLiteralText)
						requestDefer.resolve([parameterMapping.stringValue]);
					
					else if (parameterMapping.templateSegment !== undefined)
					{
						// Endpoint to get additional items from
						var endpoint;
						
						// Transform function to be used once endpoint results are returned
						var transformer;
						
						// Parameters to send with the endpoint request
						var endpointParams = {};
						
						// Retrieve segment for verification from loaded selectize options
						var segment = scope.selectizeOptions.getSelectizeOptions().options
							.find(function(templateSegment)
							{
								return templateSegment.id.toString() === parameterMapping.templateSegment.toString();
							});
						
						if (!segment)
							requestDefer.reject();
						else
						{
							function unableToVerify()
							{
								// Resolves the validation with being unable to verify constraint
								parameterMapping.parameter.constraintResult = 3;
								defer.resolve();
							};
							
							// Switch statement for segment types to get items required for verification on parameters
							switch (segment.type.id)
							{
								// Tags
								case 2:
								{
									// Tag parent and segment tag parent are the same and the depths match, the defer is resolved.
									if (parameterMapping.parameter.tagParentConstraint && segment.tagValue &&
										segment.tagValue.id === parameterMapping.parameter.tagParentConstraint.id
										&& segment.depth === parameterMapping.parameter.tagDepth)
									{
										defer.resolve();
										parameterMapping.parameter.constraintResult = 0;
									}
									else if (segment.tagValue && !isNaN(parseInt(segment.depth)))
										scope.getTagValuesPromise(segment.tagValue.id, segment.depth)
											.then(function(tagValues)
											{
												tagValues = tagValues.map(function(tagValue) { return tagValue.stringValue; });
												requestDefer.resolve(tagValues);
											});
									else
										unableToVerify();
									
									break;
								}
								
								// Choice list
								case 8:
								{
									// If the choicelist and segment choice lists are the same, the defer is resolved.
									if (parameterMapping.parameter.choiceListConstraint
										&& segment.choiceList.id === parameterMapping.parameter.choiceListConstraint.id)
									{
										defer.resolve();
										parameterMapping.parameter.constraintResult = 0;
									}
									else
									{
										scope.getChoiceListItemsPromise(segment.choiceList.id)
											.then(function(choiceListItems)
											{
												requestDefer.resolve(choiceListItems.map(function(choiceListItem) { return choiceListItem.value; }));
											});
									}
									break;
								}
								
								default:
								{
									unableToVerify();
								}
							}
						}
						
						if (typeof endpoint === 'string' && typeof transformer === 'function')
						{
							$http.get(endpoint, { params: endpointParams })
								.then(function(results)
								{
									requestDefer.resolve(transformer(results))
								});
						}
					}
					
					else
						defer.reject();
					
					// On resolve of request, results are send to parameter for verification
					requestDefer.promise.then(function(testStr)
					{
						parameterMapping.parameter.verifyForSave(testStr)
							.then(function(result)
							{
								/**
								 * Set parameter verification results onto parameter
								 * 0 - All Items match.
								 * 1 - Some items match.
								 * 2 - No items match.
								 */
								
								if (!result.hasAll && !result.hasSome)
								{
									parameterMapping.parameter.constraintResult = 2;
									defer.reject();
									return;
								}
								
								parameterMapping.parameter.constraintResult = (!result.hasAll && result.hasSome)
									? 1
									: 0;
								
								defer.resolve();
								
							}, function()
							{
								defer.reject();
							})
					}, function()
					{
						defer.reject();
					});
					
				}
				else
					// Resolve if there is no additional verification
					defer.resolve();
				
				return defer.promise;
			}))
			
			// Set save status based on all promises
			.finally(function()
			{
				readyForSave = Object.values(verificationResults)
					.map(function(result)
					{
						return (result.required) ? result.result : true;
					})
					.every(function(result)
					{
						return result
					})
			});
		};
		
		scope.getReadyForSave = function()
		{
			return readyForSave;
		};
		
		/**
		 * Returns a promise to be resolved with batch requests of its savable items.
		 * If the alert trigger has not been saved before it is saved first and not added to the batch.
		 * @returns {Promise}
		 */
		scope.saveTrigger = function()
		{
			var batch = [];
			return $q(function(resolve)
			{
				resolve($http.post('/api/reportAlertTriggers', scope.trigger.getSaveModel(scope.baseUrl))
					.then(function(result)
					{
						return result.data;
					}));
			})
			.then(function(trigger)
			{
				scope.trigger.setId(trigger.id);
				return scope.trigger.parameterMappings.map(function(parameterMapping)
					{
						return batchRequest.req(
							'POST',
							'/api/reportAlertTriggerParameterMappings',
							parameterMapping.getSaveModel(scope.baseUrl)
						)
					})
						.concat(batch);
			})
		};
		
		/**
		 * Deletes the Alert Trigger
		 */
		scope.deleteTrigger = function()
		{
			if (typeof scope.onDelete === 'function')
				scope.onDelete(scope);

			scope.$destroy();
		};
		
		/**
		 * Creates a function on the provided function to be used for verifying the constraint on it
		 * @param {AlertParameter} parameter
		 */
		scope.getParameterConstraint = function(parameter)
		{
			// Setup choice list constraint verification function
			if (parameter.choiceListConstraint)
			{
				parameter.verifyForSave = function(strings)
				{
					var defer = $q.defer();
					
					if (!Array.isArray(strings) || strings.length <= 0)
						defer.reject();
					
					else
					{
						parameter.choiceListItemsPromise.then(function(items)
						{
							var toReturn = {
								hasAll: true,
								hasSome: false
							};
							
							var values = items.map(function(item) { return item.value.toLowerCase(); });
							
							strings.forEach(function(testStr)
							{
								var index = values.findIndex(function(value) { return value === testStr.toLowerCase() });
								
								toReturn.hasAll = (!toReturn.hasAll) ? false : index >= 0;
								toReturn.hasSome = (toReturn.hasSome) ? true : index >= 0;
							});
							
							defer.resolve(toReturn);
						});
					}
					
					return defer.promise;
				};
			}
			
			// Setup tag parent constraint verification function
			else if (parameter.tagParentConstraint)
			{
				if (!isNaN(parseInt(parameter.tagDepth)))
					parameter.constraintText += ' to a depth of ' + parameter.tagDepth;
				
				parameter.verifyForSave = function(strings)
				{
					var defer = $q.defer();
					
					if (!Array.isArray(strings) || strings.length <= 0)
						defer.reject();
					
					else
					{
						parameter.tagValuesPromise.then(function(items)
						{
							var toReturn = {
								hasAll: true,
								hasSome: false
							};
							
							var values = items.map(function(item) { return item.stringValue.toLowerCase(); });
							
							strings.forEach(function(testStr)
							{
								var index = values.findIndex(function(value) { return value === testStr.toLowerCase() });
								
								toReturn.hasAll = (!toReturn.hasAll) ? false : index >= 0;
								toReturn.hasSome = (toReturn.hasSome) ? true : index >= 0;
							});
							
							defer.resolve(toReturn);
						})
					}
					
					return defer.promise;
				}
			}
		};
		
		/**
		 * Returns a promise to be resolved with all choiceList items of a choice list ID
		 * @param {Number} choiceListId
		 * @return {Promise}
		 */
		scope.getChoiceListItemsPromise = function(choiceListId)
		{
			var defer = $q.defer();
			var choiceListPromises = [];
			var maxPages = 0;
			
			$http.get('/api/choiceListItems', { params: { listId: choiceListId, size: 1 }})
				.then(function(results)
				{
					maxPages = Math.ceil(results.data.page.totalElements / 1000);
					for (var i = 0; i < maxPages; i++)
					{
						choiceListPromises.push($http.get('/api/choiceListItems', { params: { listId: choiceListId, page: i } }))
					}
					
					return $q.all(choiceListPromises)
				})
				.then(function(results)
				{
					defer.resolve(
						results.map(function(result) { return result.data._embedded.choiceListItems })
							.reduce(function(arr, value){ return arr.concat(value) }, [])
					)
				});
			
			return defer.promise;
		};
		
		/**
		 * Returns a promise to be resolved with all child tags of a parent tag up to a depth
		 * @param {Number} parentId - Parent Tag ID
		 * @param {Number=} depth - Depth to retrieve. On Null or < 1 no depth will be specified.
		 * @return {Promise}
		 */
		scope.getTagValuesPromise = function(parentId, depth)
		{
			var defer = $q.defer();
			var tagValuePromises = [];
			var maxPages = 0;
			
			var url = '/api/tagValues?parentDepthSpec=' + parentId;
			
			if (!isNaN(parseInt(depth) && depth >= 1))
				url += '&parentDepthSpec=' + depth;
			
			$http.get(url, { params: { size: 1 }})
				.then(function(results)
				{
					maxPages = Math.ceil(results.data.page.totalElements / 1000);
					for (var i = 0; i < maxPages; i++)
					{
						tagValuePromises.push($http.get(url, { params: { page: i } }))
					}
					
					return $q.all(tagValuePromises)
				})
				.then(function(results)
				{
					defer.resolve(
						results.map(function(result) { return result.data._embedded.tagValues })
							.reduce(function(arr, value){ return arr.concat(value) }, [])
					)
				});
			
			return defer.promise;
		};

		if (typeof scope.onBind === 'function')
			scope.onBind(scope);
		
		scope.alert.parameters.forEach(function(param)
		{
			scope.getParameterConstraint(param);
			
			if (param.choiceListConstraint)
				param.choiceListItemsPromise = scope.getChoiceListItemsPromise(param.choiceListConstraint.id);
			
			if (param.tagParentConstraint)
				param.tagValuesPromise = scope.getTagValuesPromise(param.tagParentConstraint.id, param.tagDepth);
		});
		
		scope.verificationCountdown();

		$(elem).on('input', 'input.literal-text-input.form-control', function($event)
		{
			var self = this;
			$timeout(function()
			{
				var parameter = scope.alert.parameters[$(self).attr('index')];
				var parameterMap = scope.trigger.parameterMappings
					.find(function(parameterMap) { return parameterMap.parameter.id === parameter.id });

				parameterMap.stringValue = $(self).val();
				scope.verificationCountdown();
			});
			$event.stopPropagation();
		});

		$(elem).on('input', 'input.template-selector', function($event)
		{
			$event.stopPropagation();
		})
	}
}
}]);

/**
 * Creates a map of Sub Templates based on ordering of templateSegments provided
 * @param templateSegments {{name: string, id: number, type: {id: number}}[]}
 */
export function SubTemplateMap(templateSegments)
{
	/**
	 * @type {{Segments: [], Custom: []}}
	 */
	var segments = {
		Segments: [],
		Custom: []
	};

	var subTemplates = [];

	/**
	 *
	 * @return {{}}
	 */
	this.getSubTemplateMap = function()
	{
		return segments;
	};

	this.hasSegmentId = function(id)
	{
		var keys = Object.keys(segments);
		for (var i = 0; i < keys.length; i++)
		{
			var localSegments = segments[keys[i]];
			if (localSegments.findIndex(function(segment) { return segment.id == id; }) > -1)
				return true;
		}
		return false;
	};


	this.getReportBuilderFormatted = function(template)
	{
		template.subTemplates = subTemplates;
		return template;
	};

	/**
	 * @param {number=} subTemplateId
	 * @return {{optgroupLabelField: string, optgroups: [], optGroupField: string, options: [], optgroupValueField: string}}
	 */
	this.getSelectizeOptions = function(subTemplateId)
	{
		var toReturn = {
			optGroupField: 'itemGroup',
			optgroupLabelField: 'groupName',
			optgroupValueField: 'groupName',

			optgroups: [],
			options: []
		};

		function formatSegments(subTemplate, segments)
		{
			toReturn.optgroups.push({ groupName: subTemplate });
			toReturn.options.push(segments[subTemplate]
				.filter(function(segment)
				{
					return typeof segment.name === 'string';
				})
				.map(function(segment)
				{
					segment.itemGroup = subTemplate;
					return segment;
				}));
		};

		if (subTemplateId != undefined)
		{
			var subTemplate = subTemplates.find(function(segment) { return segment.id == subTemplateId });
			if (subTemplate)
			{
				formatSegments(subTemplate.name, segments);
			}
			formatSegments('Segments', segments);
		}
		else
			for (var subTemplate in segments)
			{
				formatSegments(subTemplate, segments);
			}

		toReturn.options = toReturn.options.reduce(function(arr, current)
		{
			return arr.concat(current);
		}, []);

		return toReturn;
	};


	if (!Array.isArray(templateSegments))
		return;

	var currentSub = undefined;
	templateSegments.forEach(function(segment)
	{
		if (!segment.type)
		{
			segments.Custom.push(segment);
		}
		else if (segment.type.id === 5)
		{
			currentSub = segment;
			segments[segment.name] = [];
			subTemplates.push(segment);
		}
		else if (!currentSub)
		{
			segments.Segments.push(segment);
		}
		else
		{
			segments[currentSub.name].push(segment);
		}
	});

}